let primary = '#00995C'
if (window.location.href.includes('cynthia-charone')) {
  primary = '#db4247'
}
const colors = {
  primary,
  grayBackground: '#F2F3F5',
  strongGray: '#7A899F',
  mostStrongestGray: '#4D4D4D',
  grayButtonBackground: '#E1E5EA',
  placeholder: '#7A899F',
  softGray: '#CDD6E0',
  background: '#fff',
  strongRed: '#E13A33',
  softRed: '#FCE9E9',
  strongYellow: '#E5971A',
  strongGreen: '#00995C',
  softGreen: '#EBFFF7',
  softYellow: '#FDF4E8',
  titleStrongBlack: '#232323',
  strongBlack: '#262626',
  titleStrongWhite: '#FFFFFF',
  strongBlue: '#1A7BD4',
  softBlue: '#E8F3FC',
  softGrayBackground: '#F6F7F9',
}

export default colors
